require("./TwoStepVerify.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        const {type, phone} = window.uiStore.get('2FA-Factor');
        this.state = {
            phone,
            canResend: true,
            counter: 0,
            status: '-',
            digits: [
                '*',
                '*',
                '*',
                '*'
            ]
        };
        GState.bind(this, [
            'tenant',
            'banner'
        ]);
        fhandler.bind(this);
    },
    onInput: function (input) {
        (!input.params.mtd || !input.params.vtoken) && navigate('/');
    },
    onDigitInput: function (index, e) {
        const value = e.target.value;
        this.state.status = '-';
        if (value.length) {
            if (this.state.digits[index] != '*')
                return;
            this.state.digits[index] = value.substr(-1);
            if (!this.state.digits.includes('*')) {
                this.state.status = 'checking';
                this.submit();
                return;
            }
            const nextCaseIndex = index + 1;
            this.state.digits[nextCaseIndex] == '*' ? this.getEl('digit-input-' + nextCaseIndex).focus() : null;
            return;
        }
        if (e.keyCode == 8) {
            if (this.state.digits[index] != '*') {
                this.state.digits[index] = '*';
                return;
            }
            this.state.digits[index > 0 ? index - 1 : index] = '*';
            this.getEl('digit-input-' + (index > 0 ? index - 1 : index)).focus();
        }
    },
    onResendCode: async function () {
        this.state.canResend = false;
        try {
            const {error, message, delay} = await AuthRequest('/resend/sms', 'POST', { phone: this.state.phone });
            fhandler.alert(message, error ? 'info' : 'success');
            !error && this.beforeResend(delay);
        } catch (error) {
            fhandler.alert(error, 'warning');
        }
    },
    submit: async function () {
        const Form = {
            token: this.input.params.vtoken,
            index: Number(this.state.digits.join(''))
        };
        try {
            const {error, message, credentials} = await AuthRequest('/two-step/verify/' + this.input.params.mtd, 'POST', Form);
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return this.state.status = 'wrong';
            this.state.status = 'valid';
            window.uiStore.update('2FA-Factor', { ignore: true }, 'add');
            this.grantAccess(credentials);
        } catch (error) {
            this.state.status = 'wrong';
            fhandler.alert(error, 'warning');
        }
    },
    beforeResend: function (delay) {
        this.state.counter = delay;
        let countTimer = setInterval(() => {
            if (this.state.counter > 0) {
                this.state.counter--;
                return;
            }
            this.state.canResend = true;
            clearInterval(countTimer);
        }, 1000);
    },
    grantAccess: function (credentials) {
        const {ctoken, deviceId, type, role} = credentials || this.input.params;
        if (!ctoken || !deviceId || !type || !role)
            return navigate('/signout');
        let queries = Obj2Params({
            ctoken,
            deviceId,
            type,
            role
        });
        if (isDefaultDomain())
            queries += '&redirectTo=/onboarding';
        else {
            if (this.input.params.hasOwnProperty('redirectTo'))
                queries += '&redirectTo=' + encodeURIComponent(this.input.params.redirectTo);
        }
        document.location = `/authorize?${ queries }`;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/TwoStepVerify.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    TenantLogo_template = require("../../../components/TenantLogo/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    TenantLogo_tag = marko_loadTag(TenantLogo_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    AuthLayout_template = require("../../components/AuthLayout/index.marko"),
    AuthLayout_tag = marko_loadTag(AuthLayout_template),
    marko_attrs0 = {
        "class": "card-header w-100 text-center pb-0"
      },
    marko_attrs1 = {
        "class": "card-body"
      },
    marko_attrs2 = {
        "class": "mx-50"
      },
    marko_attrs3 = {
        "class": "mb-4"
      },
    marko_attrs4 = {
        "class": "blue-grey-text font-medium-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("590a0b"),
    marko_node0 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "font-medium-1"
      },
    marko_node2 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "font-medium-1 mx-50 mt-6"
      },
    marko_attrs7 = {
        "class": "col"
      },
    marko_attrs8 = {
        "class": "text-muted mx-50"
      },
    marko_node4 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      });

const fhandler = new FormHandler({ key: 'signin-form' });

function render(input, out, __component, component, state) {
  var data = input;

  AuthLayout_tag({
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        TenantLogo_tag({}, out, __component, "2");

        out.ee();

        out.be("div", marko_attrs1, "3", component);

        FormAlert_tag({
            alert: state.alert,
            class: "mx-50"
          }, out, __component, "4");

        out.be("div", marko_attrs2, "5", component);

        out.be("h5", marko_attrs3, "6", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("We just message you the code.");
            }
          }, out, __component, "7");

        out.ee();

        out.e("p", marko_attrs4, "8", component, 1)
          .t(state.phone, component);

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        out.be("p", marko_attrs5, "11", component);

        Locale_tag({
            text: "Verification code"
          }, out, __component, "12");

        out.ee();

        Row_tag({
            class: "digit-inputs",
            renderBody: function(out) {
              var $for$0 = 0;

              marko_forRange(0, 3, 1, function(index) {
                var $keyScope$0 = "[" + (($for$0++) + "]");

                out.e("div", marko_attrs7, "14" + $keyScope$0, component, 1)
                  .e("input", {
                      type: "number",
                      max: "1",
                      onKeyPress: "if(this.value.length==1) return false",
                      disabled: [
                          "checking",
                          "valid"
                        ].includes(state.status),
                      value: state.digits[index] != "*" ? state.digits[index] : "",
                      "class": marko_classValue(marko_classValue([
                        "theme-bg border rounded",
                        state.status
                      ])),
                      style: "outline:0"
                    }, "@" + ("digit-input-" + index), component, 0, 0, {
                      onkeyup: __component.d("keyup", "onDigitInput", false, [
                          index
                        ])
                    });
              });
            }
          }, out, __component, "13");

        out.n(marko_node2, component);

        out.n(marko_node3, component);

        if (state.counter > 0) {
          out.be("small", marko_attrs8, "17", component);

          out.t(state.counter, component);

          out.t(" ");

          Locale_tag({
              text: "Seconds"
            }, out, __component, "18");

          out.ee();

          out.n(marko_node4, component);

          out.n(marko_node5, component);
        }

        out.be("button", {
            type: "submit",
            disabled: !state.canResend,
            "class": "btn btn-primary btn-xl text-left w-100"
          }, "21", component, null, 0, {
            onclick: __component.d("click", "onResendCode", false)
          });

        Bx_tag({
            type: "phone",
            class: "font-large-1 float-right white-text"
          }, out, __component, "22");

        Locale_tag({
            text: "Resend Code"
          }, out, __component, "23");

        out.ee();

        out.ee();

        out.be("div", marko_attrs6, "24", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Already have an account?");
            }
          }, out, __component, "25");

        out.t(" ");

        route_link_tag({
            href: "/signin",
            class: "font-medium-1",
            renderBody: function(out) {
              Locale_tag({
                  text: "Sign-in"
                }, out, __component, "27");
            }
          }, out, __component, "26");

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
